<template>
    <v-container>
        <v-card slot="rightContainer" outlined>
            <v-card-title class="grey lighten-4">
                <b>HISTORICO ORDENES DE EQUIPAMIENTO</b>
                <v-spacer />
                <v-col cols="12" sm="3">
                    <v-menu ref="menu" v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="auto">
                        <template #activator="{ on, attrs }">
                            <v-text-field v-model="fechaFiltro" hide-details="auto" dense label="FILTRAR POR RANGO - MES"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                        </template>
                        <v-date-picker v-model="fechaFiltro" range no-title scrollable>
                            <v-spacer />
                            <v-btn text color="primary" @click="menu3 = false"> CERRAR </v-btn>
                            <v-btn color="primary" :loading="loadingLista" @click="getLista"> BUSCAR </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field dense v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line
                        hide-details />
                </v-col>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table multi-sort :search="search" :items="listaOEqui" :headers="headers" class="elevation-1"
                            :items-per-page="20">
                            <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="orange lighten-2" small
                                            @click="calltoprint(item)">mdi-factory</v-icon>
                                    </template>
                                    <span>Descargar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="teal" small
                                            @click="sendToInventario(item)">mdi-tray-plus</v-icon>
                                    </template>
                                    <span>Enviar a Inventario</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="red" small
                                            @click="closePosition(item)">mdi-clock-in</v-icon>
                                    </template>
                                    <span>Cerrar Orden</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.statusName`]="{ item }">
                                <v-chip dark :color="item.statusName === 'ACTIVE' ? 'green' : 'red'" class="white--text font-weight-bold" small>
                                    {{ item.statusName }}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { format, subDays, addDays } from 'date-fns'
import request from '@/utils/request'

export default {
    data() {
        return {
            fechaFiltro: [format(subDays(new Date(), 31), 'yyyy-MM-dd'), format(addDays(new Date(), 1), 'yyyy-MM-dd')],
            menu3: false,
            loadingLista: false,
            dataProducto: '',
            search: '',
            headers: [
                { text: '', value: 'action', sortable: false },
                { text: 'ID', value: 'id' },
                { text: 'status', value: 'statusName' },

                { text: 'fechaEmision', value: 'fechaEmision' },
                { text: 'vendedor', value: 'vendedor' },
                { text: 'personalCargo', value: 'personalCargo' },

                { text: 'ordenPedido', value: 'ordenPedido' },
                { text: 'Fecha de Entrega', value: 'fechaEntregaVenta' },
                { text: 'producto', value: 'producto' },
                { text: 'color', value: 'color' },
                { text: 'medida', value: 'medida' },

                { text: 'material', value: 'material' },
                { text: 'observaciones', value: 'observaciones' }
            ]
        }
    },
    computed: {
        ...mapGetters('inventario', ['ordenEquipamiento']),
        ...mapState('ventas', ['datos']),
        ...mapState('users', ['user']),
        listaOEqui() {
            let newLista = []
            if (this.ordenEquipamiento.length > 0) {
                this.ordenEquipamiento.map((x) => {
                    // Mostrar fechaEntregaVenta - 2 dias (solo visual, no toca el dato original)
                    let fechaEntregaVenta = x.fechaEntregaVenta
                    if (fechaEntregaVenta) {
                        try {
                            const partes = String(fechaEntregaVenta).split('T')[0].split('-')
                            const fecha = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))
                            fechaEntregaVenta = format(subDays(fecha, 2), 'yyyy-MM-dd')
                        } catch (e) {
                            // si el formato es inesperado, mostrar tal cual
                        }
                    }
                    newLista.push({
                        ...x,
                        fechaEntregaVenta,
                        items: x.items ? JSON.parse(x.items) : [],
                        statusName: x.status == 1? 'ACTIVE': "CERRADO"
                    })
                })
            }

            return newLista
        }
    },
    methods: {
        async getLista() {
            this.loadingLista = true
            await this.$store.dispatch('inventario/getListaOrdenEquipamiento', { fechaFiltro: this.fechaFiltro })

            this.loadingLista = false
            this.menu3 = false
        },

        async calltoprint(item) {
            try {
                console.log('Descargando orden para item:', item.id)
                var today = new Date()
                var dd = today.getDate()
                var mm = today.getMonth() + 1 //January is 0!
                var yyyy = today.getFullYear()

                if (dd < 10) {
                    dd = '0' + dd
                }

                if (mm < 10) {
                    mm = '0' + mm
                }

                today = yyyy + '-' + mm + '-' + dd
                console.log('item', item)
                const dataOrdenEquipamiento = await this.$store.dispatch('ventas/traerOrdenesEquipamiento', { id: item.id })
                console.log('dataOrdenEquipamiento obtenida:', dataOrdenEquipamiento)
                
                if (!dataOrdenEquipamiento || dataOrdenEquipamiento.length === 0) {
                    throw new Error('No se encontraron datos de la orden')
                }

                const orden = dataOrdenEquipamiento[0]
                
                // Ensure items is parsed correctly
                const items = orden.items || item.items || []
                const itemsParsed = typeof items === 'string' ? JSON.parse(items) : items

                // Obtener image_url de la venta asociada
                let image_url = null
                if (orden.ordenPedido) {
                    try {
                        const venta = await this.$store.dispatch('ventas/ventaProducto', { id: orden.ordenPedido })
                        if (venta && venta.productos) {
                            const productos = typeof venta.productos === 'string' ? JSON.parse(venta.productos) : venta.productos
                            const prodMatch = productos.find(p => p.image_url)
                            image_url = prodMatch?.image_url || null
                        }
                    } catch (e) {
                        console.warn('No se pudo obtener image_url de la venta:', e.message)
                    }
                }

                await this.$store.dispatch('reporte/reporteOrdenEquipamiento', {
                    orden: item.id,
                    vendedor: orden.vendedor || '',
                    fecha: today,
                    ordenpedido: orden.ordenPedido || 0,
                    personacargo: orden.personalCargo || '',
                    producto: orden.producto || '',
                    model: orden.modelo || '',
                    medida: orden.medida || 'NO DEFINIDO',
                    color: orden.color || 'NO DEFINIDO',
                    posicion: orden.posicion || '-',
                    observacion: orden.observaciones || '',
                    items: itemsParsed,
                    image_url
                })
                console.log('Reporte descargado exitosamente')
            } catch (error) {
                console.error('Error descargando orden:', error)
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'Error al descargar reporte: ' + error.message,
                    color: 'red',
                    close: true
                })
            }
        },
        async closePosition(item) {
            console.log('itemAQUIIII--------------------', item)
            await this.$store.dispatch('inventario/closeOrdenEquipamiento', {
                data: {
                    status: !item.status
                },
                id: item.id
            })
            // Si se cierra la orden (status pasa a 0/false), auto-fill PROCESO INTERNO en la venta
            if (item.status === 1 && item.ordenPedido) {
                const today = format(new Date(), 'yyyy-MM-dd')
                try {
                    // El PATCH de LoopBack reemplaza el objeto JSON completo de atributos,
                    // así que primero leemos los actuales y mergeamos encima. Si el GET o el
                    // parse fallan, no se envía el PATCH (mejor no actualizar que borrar datos).
                    const { data: venta } = await request({
                        url: `/api-loopback/tm_ventas/${item.ordenPedido}`,
                        method: 'GET'
                    })
                    const attrs = venta && venta.atributos
                    const atributosActuales = typeof attrs === 'string' ? JSON.parse(attrs || '{}') : (attrs || {})
                    await this.$store.dispatch('ventas/patchVenta', {
                        id: item.ordenPedido,
                        atributos: {
                            ...atributosActuales,
                            fechaEquipamiento: today,
                            encargadoEquipamiento: item.personalCargo
                        }
                    })
                } catch (e) {
                    console.error('Error al actualizar PROCESO INTERNO:', e)
                }
            }
            await this.getLista()
        },

        sendToInventario(item) {
            const items = item.items ? (typeof item.items === 'string' ? JSON.parse(item.items) : item.items) : []

            // Guardar items en sessionStorage para evitar truncamiento por URL length
            const payload = {
                ordenId: item.id,
                vendedor: item.vendedor || '',
                personalCargo: item.personalCargo || '',
                ordenPedido: item.ordenPedido || '',
                producto: item.producto || '',
                observaciones: item.observaciones || '',
                items
            }
            sessionStorage.setItem('ordenEquipamientoPayload', JSON.stringify(payload))

            this.$router.push({
                path: '/logistica/inventary',
                query: {
                    fromOrdenEquipamiento: 'true',
                    ordenId: item.id
                }
            })
        }
    },
    async mounted() {
        await this.getLista()
        // idProducto llega por query string: si la vista se abre sin ese
        // parametro no hay nada que consultar (antes se enviaba ?id=undefined).
        const idProducto = this.$route.query.idProducto
        if (!idProducto) return
        const obtenerProducto = await this.$store.dispatch('ventas/obtenerProducto', {
            id: idProducto,
            idSede: this.user?.idSede
        })
        this.dataProducto = obtenerProducto
    }
}
</script>
